import { BillingMode } from '@zeus/index'
import { useTranslation } from 'react-i18next'
import { Label } from '~/components/ui/label'

type Props = {
  mode: BillingMode
  note: string
  onModeChange: (mode: BillingMode) => void
  onNoteChange: (note: string) => void
}

/** Taille de la colonne `managedNote`. */
const NOTE_MAX = 500

/**
 * Qui tient le compte de l'organisation (#349) : elle-même, en souscrivant, ou
 * Studeva, hors abonnement. La note ne sert qu'à Studeva : l'organisation ne la
 * voit jamais.
 */
function OrganizationBillingModeField({ mode, note, onModeChange, onNoteChange }: Props) {
  const { t } = useTranslation()

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="org-billing-mode">{t('organization.edit.billingMode')}</Label>
        <select
          id="org-billing-mode"
          value={mode}
          onChange={e => onModeChange(e.target.value as BillingMode)}
          aria-describedby="org-billing-mode-help"
          className="h-9 w-full rounded-md border border-input bg-transparent px-3 text-sm"
        >
          <option value={BillingMode.SELF_SERVICE}>{t('billing.mode.SELF_SERVICE')}</option>
          <option value={BillingMode.MANAGED}>{t('billing.mode.MANAGED')}</option>
        </select>
        <p id="org-billing-mode-help" className="text-xs text-muted-foreground">{t(`billing.mode.${mode}.help`)}</p>
      </div>
      {mode === BillingMode.MANAGED && (
        <div className="space-y-2">
          <Label htmlFor="org-billing-note">{t('organization.edit.billingNote')}</Label>
          <textarea
            id="org-billing-note"
            value={note}
            maxLength={NOTE_MAX}
            rows={3}
            onChange={e => onNoteChange(e.target.value)}
            aria-describedby="org-billing-note-help"
            className="w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm"
          />
          <p id="org-billing-note-help" className="text-xs text-muted-foreground">{t('organization.edit.billingNote.help')}</p>
        </div>
      )}
    </div>
  )
}

export default OrganizationBillingModeField
